<template>
    <div id="premium-tab" class="container tab-pane"><br>
        <h2>{{ $t('settings.blockAll') }}</h2>
        <p>{{ $t('settings.blockAllDesc') }}</p>
        <div class="form-group"
             v-for="premium in premiums.checkboxes"
             :key="premium.key"
        >
            <div class="custom-control custom-switch">
                <input type="checkbox"
                       class="custom-control-input"
                       :id="'premium'+premium.key"
                       :checked="premium.value"
                       @change="changeSetting(premium.key, premium.value)"
                >
                <label class="custom-control-label" :for="'premium'+premium.key">{{ $t('settings.'+ premium.key) }}<span :title="$t('settings.'+ premium.key + 'Desc')"><sup>&#9432;</sup></span></label>
            </div>
        </div>
        <hr>
        <h2>{{ $t('settings.limitSettings') }}</h2>
        <p>{{ $t('settings.limitDesc') }}</p>
        <div class="form-group">
            <label class="form-check-label" for="premium-costLimit">{{ $t('settings.costLimit') }}</label>
            <input type="number"
                   :max="costLimitMaxCombined"
                   class="form-control"
                   id="premium-costLimit"
                   v-model="costLimit"
            >
            <div v-if="dirtyCostLimit">
                <button class="red-button" @click="submitCostLimit">
                    {{ $t('pages.administration.tab5.button') }}
                </button>
            </div>
        </div>
        <hr>
        <h2>{{ $t('settings.roamingTitle') }}</h2>
        <div class="form-group"
             v-for="premium in premiums.roaming"
             :key="premium.key"
        >
            <div class="custom-control custom-switch">
                <input type="checkbox"
                       class="custom-control-input"
                       :id="'roaming'+premium.key"
                       :checked="premium.value"
                       @change="changeRoamingSetting(premium.key, premium.value)"
                >
                <label class="custom-control-label" :for="'roaming'+premium.key">{{ $t('settings.'+ premium.key) }}<span :title="$t('settings.'+ premium.key + 'Desc')"><sup>&#9432;</sup></span></label>
            </div>
        </div>
        <div class="form-group">
            <label class="form-check-label" for="premium-costLimitRoaming">{{ $t('settings.costLimitRoaming') }}</label>
            <input type="number"
                   :max="costLimitMaxCombined"
                   class="form-control"
                   id="premium-costLimitRoaming"
                   v-model="costLimitRoaming"
            >
            <div v-if="dirtyCostLimitRoaming">
                <button class="red-button" @click="submitCostLimitRoaming">
                    {{ $t('pages.administration.tab5.button') }}
                </button>
            </div>
        </div>
        <br>
    </div>
</template>

<script>
import Premium from './Premium';
export default Premium;
</script>
